import React, { useEffect, useState } from "react";
import "./App.css";
import { Link, Redirect } from "react-router-dom";
import Axios from "axios";
import ClipLoader from "react-spinners/ClipLoader";
import Footer from "./components/Footer";
import {
  IoIosContact,
  IoIosCalendar,
  IoIosBarcode,
  IoIosCard,
  IoMdHeartEmpty,
  IoMdPerson,
  IoIosLock,
  IoIosPaper,
  IoIosInformationCircleOutline,
  IoIosLogOut,
  IoIosRemoveCircleOutline,
  IoIosCheckmarkCircleOutline,
  IoIosArrowBack,
} from "react-icons/io";
import { AiOutlineQrcode } from "react-icons/ai";
import { RiQrCodeLine } from "react-icons/ri";
import Header2 from "./components/Header2";
import { BsQrCode } from "react-icons/bs";
import {
  useHistory,
  useLocation,
} from "react-router-dom/cjs/react-router-dom.min";
import Header from "./layouts/Header";

var QRCode = require("qrcode.react");

const Zoom = () => {
  const history = useHistory();
  const location = useLocation();
  const {
    transactiondate,
    venue,
    eventtime,
    eventday,
    yearcreated,
    theme,
    admissions,
    totalcost,
    ticketnumber,
    eventid,
    refund_status,
  } = location.state;

  const [qrPayload, setQrPayload] = useState("");
  const [loading, setLoading] = useState(true);

  const customername = localStorage.getItem("customername");
  const customerid = localStorage.getItem("customerid");
  document.title = customername;
  const baseURL = "https://karamale.com/apps/kscanner/webservices.php";
  useEffect(() => {
    Axios.get(
      baseURL +
        "?query=ZOOM-IN-TICKET&customerid=" +
        customerid +
        "&eventid=" +
        eventid +
        "&ticket_number=" +
        ticketnumber,
      {
        withCredentials: true,
      }
    )
      .then((response) => {
        setQrPayload(response.data.qr_payload ?? "");
        setTimeout(() => {
          setLoading(false);
        }, 1000);
      })
      .catch((error) => console.log(error));
  }, []);

  if (localStorage.getItem("customername") === null) {
    return <Redirect to="/login" />;
  }
  return (
    <div className="view mt-5">
      <Header />
      <div className="container pb-5">
        <div className="row justify-content-center just-container-insid">
          <div className="col-lg-7 pl-0 pr-0">
            <div className=" BoxDashboardContainer mt-5 mb-4 mrgin-search pl-0 pr-0">
              <div className="row align-self-center justify-content-center">
                <div className="item-list p-0">
                  <div className="col-lg-4 col-4 pl-0">
                    <button
                      type="button"
                      onClick={() => history.goBack()}
                      className="link-btn"
                    >
                      <IoIosArrowBack size={25} />
                      Back &nbsp;
                    </button>
                  </div>

                  <div className="col-lg-8 col-8 text-right">
                    <label className="back-arrow">
                      <IoIosInformationCircleOutline size={40} color={"#fff"} />
                      &nbsp;&nbsp;&nbsp;{" "}
                      <span className="note-info">{ticketnumber}</span>
                    </label>
                  </div>
                </div>
              </div>
            </div>

            {loading ? (
              <div className=" BoxDashboardContainer pl-0 pr-0">
                <div className="row">
                  <div className="col-12 text-center">
                    <ClipLoader size={25} color="grey" />
                  </div>
                </div>
              </div>
            ) : (
              <div className=" BoxDashboardContainer pl-0 pr-0">
                <div className="row align-self-center justify-content-center">
                  <div className="item-list p-0">
                    <div className="col-lg-12 text-center">
                      <label className="pl-0 pr-0 text-bold">
                        {refund_status === "Pending" ? (
                          <div className="alert alert-info p-2 mb-0 font-normal">
                            Refund request submitted. Awaiting review.
                          </div>
                        ) : refund_status === "Under_review" ? (
                          <div className="alert alert-info p-2 mb-0 font-normal">
                            Refund request under review. We'll notify you once a
                            decision is made.
                          </div>
                        ) : refund_status === "Approved" ? (
                          <div className="alert alert-warning p-2 mb-0 font-normal">
                            This ticket has been refunded and is no longer
                            valid.
                          </div>
                        ) : (
                          <h6 className="mb-0">
                            Show this Karamale QR code at the entrance to unlock
                            the moment.
                          </h6>
                        )}
                      </label>
                    </div>
                  </div>

                  <div className="h-divider w-100"></div>
                </div>
                <div className="col-12 text-center pb-5 pt-3">
                  {qrPayload === "" ? (
                    <>
                      <label
                        style={{
                          paddingTop: "5px",
                          paddingBottom: "5px",
                          paddingLeft: "10px",
                          paddingRight: "10px",
                          borderRadius: "5px",
                          backgroundColor: "#ffcccc",
                          border: "thin solid #ff7f7f",
                          color: "#ff4c4c",
                          marginBottom: "20px",
                        }}
                      >
                        🚫 This QR code is invalid
                      </label>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  {refund_status === "Under_review" ||
                  refund_status === "Pending" ? (
                    <>
                      <label className="text-grey">
                        Ticket temporarily disabled
                      </label>
                      <br />
                    </>
                  ) : refund_status === "Approved" ? (
                    <>
                      <label className="text-grey">
                        This ticket is no longer valid
                      </label>
                      <br />
                    </>
                  ) : (
                    ""
                  )}
                  <QRCode
                    value={qrPayload}
                    logoSize={30}
                    size={250}
                    fgColor={
                      refund_status === "Pending" ||
                      refund_status === "Under_review" ||
                      refund_status === "Approved"
                        ? "#dcdcdc"
                        : "#000"
                    }
                    bgColor="#fff"
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Zoom;
